import { CashFlowItem, CashFlowItemCreateRequest } from 'bus/cash/cashFlow/types';

import { PayloadRequest } from 'types/requestTypes';

import $axios from '../utils/axios-instance';

export default class CashFlowApi {
  async getCashFlowDetail({ id }: PayloadRequest) {
    return await $axios
      .get<CashFlowItem>(`/v1/CashFlowItem/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createCashFlow(data: CashFlowItemCreateRequest) {
    return await $axios
      .post('/v1/CashFlowItem/', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeCashFlow(data: CashFlowItem) {
    return await $axios
      .put(`/v1/CashFlowItem/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteCashFlow({ id }: PayloadRequest) {
    return await $axios
      .delete(`/v1/CashFlowItem/${id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async typesCashFlow() {
    return await $axios
      .get('/v1/CashFlowItem/types')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
